import React, { useState } from 'react';
import { Wrench, CalendarDays, DollarSign, Calculator, Clock } from 'lucide-react';
import DateCalculator from '../components/tools/DateCalculator';
import InterestCalculator from '../components/tools/InterestCalculator';
import FeeCalculator from '../components/tools/FeeCalculator';
import BillingUnitConverter from '../components/tools/BillingUnitConverter';

const TOOLS = [
  { id: 'date', name: 'Date Calculator', icon: CalendarDays, description: 'Calculate dates by adding or subtracting calendar or business days', component: DateCalculator },
  { id: 'interest', name: 'Interest Calculator', icon: DollarSign, description: 'Calculate simple or compound interest', component: InterestCalculator },
  { id: 'fee', name: 'Fee Calculator', icon: Calculator, description: 'Calculate contingency fees and flat fee installments', component: FeeCalculator },
  { id: 'billing', name: 'Billing Units', icon: Clock, description: 'Convert time to billing increments', component: BillingUnitConverter },
];

const Tools = () => {
  const [activeToolId, setActiveToolId] = useState('date');
  const activeTool = TOOLS.find(t => t.id === activeToolId);
  const ActiveComponent = activeTool.component;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Wrench className="h-6 w-6 text-amber-600" />
          Tools
        </h1>
        <p className="text-sm text-gray-500 mt-1">Quick calculators and utilities for everyday legal practice</p>
      </div>

      {/* Tool selector tabs */}
      <div className="flex flex-wrap gap-2 mb-6">
        {TOOLS.map((tool) => {
          const Icon = tool.icon;
          const isActive = tool.id === activeToolId;
          return (
            <button
              key={tool.id}
              onClick={() => setActiveToolId(tool.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-white text-gray-900 border border-gray-300 shadow-md font-semibold'
                  : 'bg-white text-gray-500 border border-gray-200 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Icon className="h-4 w-4" />
              {tool.name}
            </button>
          );
        })}
      </div>

      {/* Active tool */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 max-w-2xl">
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-gray-900">{activeTool.name}</h2>
          <p className="text-sm text-gray-500">{activeTool.description}</p>
        </div>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default Tools;
